// International dialing codes (comprehensive). CH is default.
export const COUNTRY_CODES = [
  { c: "CH", d: "+41", n: "Schweiz" },
  { c: "DE", d: "+49", n: "Deutschland" },
  { c: "AT", d: "+43", n: "Österreich" },
  { c: "FR", d: "+33", n: "France" },
  { c: "IT", d: "+39", n: "Italia" },
  { c: "LI", d: "+423", n: "Liechtenstein" },
  { c: "GB", d: "+44", n: "United Kingdom" },
  { c: "US", d: "+1", n: "USA / Canada" },
  { c: "ES", d: "+34", n: "España" },
  { c: "PT", d: "+351", n: "Portugal" },
  { c: "NL", d: "+31", n: "Nederland" },
  { c: "BE", d: "+32", n: "Belgique" },
  { c: "LU", d: "+352", n: "Luxembourg" },
  { c: "IE", d: "+353", n: "Ireland" },
  { c: "DK", d: "+45", n: "Danmark" },
  { c: "SE", d: "+46", n: "Sverige" },
  { c: "NO", d: "+47", n: "Norge" },
  { c: "FI", d: "+358", n: "Suomi" },
  { c: "IS", d: "+354", n: "Ísland" },
  { c: "PL", d: "+48", n: "Polska" },
  { c: "CZ", d: "+420", n: "Česko" },
  { c: "SK", d: "+421", n: "Slovensko" },
  { c: "HU", d: "+36", n: "Magyarország" },
  { c: "RO", d: "+40", n: "România" },
  { c: "BG", d: "+359", n: "Bulgaria" },
  { c: "GR", d: "+30", n: "Ελλάδα" },
  { c: "HR", d: "+385", n: "Hrvatska" },
  { c: "SI", d: "+386", n: "Slovenija" },
  { c: "RS", d: "+381", n: "Srbija" },
  { c: "BA", d: "+387", n: "Bosna i Hercegovina" },
  { c: "MK", d: "+389", n: "Severna Makedonija" },
  { c: "AL", d: "+355", n: "Shqipëria" },
  { c: "ME", d: "+382", n: "Crna Gora" },
  { c: "XK", d: "+383", n: "Kosovo" },
  { c: "TR", d: "+90", n: "Türkiye" },
  { c: "RU", d: "+7", n: "Россия / Казахстан" },
  { c: "UA", d: "+380", n: "Україна" },
  { c: "BY", d: "+375", n: "Беларусь" },
  { c: "LT", d: "+370", n: "Lietuva" },
  { c: "LV", d: "+371", n: "Latvija" },
  { c: "EE", d: "+372", n: "Eesti" },
  { c: "MD", d: "+373", n: "Moldova" },
  { c: "GE", d: "+995", n: "Georgia" },
  { c: "AM", d: "+374", n: "Armenia" },
  { c: "AZ", d: "+994", n: "Azərbaycan" },
  { c: "CY", d: "+357", n: "Cyprus" },
  { c: "MT", d: "+356", n: "Malta" },
  { c: "AE", d: "+971", n: "United Arab Emirates" },
  { c: "SA", d: "+966", n: "Saudi Arabia" },
  { c: "QA", d: "+974", n: "Qatar" },
  { c: "KW", d: "+965", n: "Kuwait" },
  { c: "BH", d: "+973", n: "Bahrain" },
  { c: "OM", d: "+968", n: "Oman" },
  { c: "IL", d: "+972", n: "Israel" },
  { c: "JO", d: "+962", n: "Jordan" },
  { c: "LB", d: "+961", n: "Lebanon" },
  { c: "IQ", d: "+964", n: "Iraq" },
  { c: "IR", d: "+98", n: "Iran" },
  { c: "EG", d: "+20", n: "Egypt" },
  { c: "MA", d: "+212", n: "Maroc" },
  { c: "DZ", d: "+213", n: "Algérie" },
  { c: "TN", d: "+216", n: "Tunisie" },
  { c: "LY", d: "+218", n: "Libya" },
  { c: "ZA", d: "+27", n: "South Africa" },
  { c: "NG", d: "+234", n: "Nigeria" },
  { c: "KE", d: "+254", n: "Kenya" },
  { c: "ET", d: "+251", n: "Ethiopia" },
  { c: "GH", d: "+233", n: "Ghana" },
  { c: "IN", d: "+91", n: "India" },
  { c: "PK", d: "+92", n: "Pakistan" },
  { c: "BD", d: "+880", n: "Bangladesh" },
  { c: "LK", d: "+94", n: "Sri Lanka" },
  { c: "CN", d: "+86", n: "China" },
  { c: "HK", d: "+852", n: "Hong Kong" },
  { c: "TW", d: "+886", n: "Taiwan" },
  { c: "JP", d: "+81", n: "Japan" },
  { c: "KR", d: "+82", n: "South Korea" },
  { c: "TH", d: "+66", n: "Thailand" },
  { c: "VN", d: "+84", n: "Vietnam" },
  { c: "SG", d: "+65", n: "Singapore" },
  { c: "MY", d: "+60", n: "Malaysia" },
  { c: "ID", d: "+62", n: "Indonesia" },
  { c: "PH", d: "+63", n: "Philippines" },
  { c: "AU", d: "+61", n: "Australia" },
  { c: "NZ", d: "+64", n: "New Zealand" },
  { c: "BR", d: "+55", n: "Brasil" },
  { c: "AR", d: "+54", n: "Argentina" },
  { c: "CL", d: "+56", n: "Chile" },
  { c: "CO", d: "+57", n: "Colombia" },
  { c: "PE", d: "+51", n: "Perú" },
  { c: "MX", d: "+52", n: "México" },
];
